import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { personalizationExplainerAvailableDimensions } from "./constants";
import type {
  PersonalizationExplainerAvailableDimensionsParams,
  PersonalizationExplainerAvailableDimensionsResult,
} from "./types";
import { isPersonalizationExplainerAvailableDimensionsResult } from "./validators";

export const getPersonalizationExplainerAvailableDimensions = reactQueryFetcherAdapter(
  personalizationExplainerAvailableDimensions,
  (
    signal: AbortSignal,
    { appGroupId, dsaId }: PersonalizationExplainerAvailableDimensionsParams
  ): Promise<PersonalizationExplainerAvailableDimensionsResult> => {
    return fetch(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/insights/personalization_explainer/available_dimensions`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isPersonalizationExplainerAvailableDimensionsResult
);
